export default __webpack_public_path__ + "d22f56e8fbed8027fd488b6fa25006b9.svg";